export default __webpack_public_path__ + "static/img/vogue_scene_animated_0073.b9818d4.webp";